export default "__VITE_ASSET__3f29a4fc__"